var _g, _g2, _g3, _g4, _line, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTracktofloorheight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2023,
    x1: 41,
    y1: 35.1,
    x2: 41,
    y2: 221.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "37.4,36.1 41,29.9 44.6,36.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "37.4,220.2 41,226.4 44.6,220.2  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 24.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.6594,
    width: 139,
    height: 4.9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M187.6,229.5v-4.6h3v0.5h-2.4v1.5h2.4v0.5h-2.4v2.1H187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M191.3,229.5v-4.6h0.6v4.1h2.1v0.5H191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M194.9,228.4c-0.2-0.4-0.3-0.8-0.3-1.2s0.1-0.9,0.3-1.2c0.2-0.4,0.5-0.6,0.8-0.9c0.3-0.2,0.7-0.3,1.2-0.3 s0.8,0.1,1.2,0.3s0.6,0.5,0.8,0.9s0.3,0.8,0.3,1.2s-0.1,0.9-0.3,1.2c-0.2,0.4-0.5,0.6-0.8,0.9c-0.4,0.2-0.7,0.3-1.2,0.3 s-0.8-0.1-1.2-0.3C195.3,229.1,195,228.8,194.9,228.4z M195.2,227.2c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.3,0.5,0.6,0.7s0.6,0.2,0.9,0.2 c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.7s0.2-0.6,0.2-1c0-0.5-0.2-1-0.5-1.3s-0.7-0.5-1.2-0.5s-0.9,0.2-1.2,0.5 C195.3,226.2,195.2,226.7,195.2,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M200.1,228.4c-0.2-0.4-0.3-0.8-0.3-1.2s0.1-0.9,0.3-1.2c0.2-0.4,0.5-0.6,0.8-0.9c0.3-0.2,0.7-0.3,1.2-0.3 s0.8,0.1,1.2,0.3s0.6,0.5,0.8,0.9s0.3,0.8,0.3,1.2s-0.1,0.9-0.3,1.2c-0.2,0.4-0.5,0.6-0.8,0.9c-0.4,0.2-0.7,0.3-1.2,0.3 s-0.8-0.1-1.2-0.3C200.6,229.1,200.3,228.8,200.1,228.4z M200.4,227.2c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.3,0.5,0.6,0.7 s0.6,0.2,0.9,0.2c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.7s0.2-0.6,0.2-1c0-0.5-0.2-1-0.5-1.3s-0.7-0.5-1.2-0.5 s-0.9,0.2-1.2,0.5C200.6,226.2,200.4,226.7,200.4,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M205.3,229.5v-4.6h1.9c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.4,0.3s-0.3,0.1-0.5,0.1l1.2,1.9H208l-1.2-1.8h-0.9v1.8L205.3,229.5L205.3,229.5z  M205.9,227.2h1.2c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.5-0.3-0.6s-0.4-0.2-0.7-0.2h-1.2V227.2z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.0384,
    x1: 0,
    y1: 227.3,
    x2: 183,
    y2: 227.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 212,
    height: 232
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracktofloorheight);
export default __webpack_public_path__ + "static/media/tracktofloorheight.ef81efb965a5b4f55aaa31bee4c9faaf.svg";
export { ForwardRef as ReactComponent };